import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {StockTakeSearchModel} from "../stock-take-search.model";
import {StockTakeEntityModel} from "../stock-take-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {StockTakeReportComponent} from "../../reports/stock-take-report/stock-take-report.component";

@Component({
    selector: "wbo-stock-take-search-page",
    templateUrl: "./stock-take-search-page.component.html",
    providers: [provideSearchModel(StockTakeSearchModel), provideEntityModel(StockTakeEntityModel)]
})
export class StockTakeSearchPageComponent extends AbstractSearchPage {

    StockTakeReportComponent = StockTakeReportComponent;
}
